import Types from "./types";

const setProgressBarData = (data) => ({
    type: Types.SET_PROGRESS_BAR_DATA,
    data
});

const setVisitedState = (index, params) => ({
    type: Types.SET_VISITED_STATE,
    index,
    params
});

export {
    setProgressBarData,
    setVisitedState
};
